import { render, staticRenderFns } from "./rankingListTM.vue?vue&type=template&id=049f0b2e&scoped=true&"
import script from "./rankingListTM.vue?vue&type=script&lang=js&"
export * from "./rankingListTM.vue?vue&type=script&lang=js&"
import style0 from "./rankingListTM.vue?vue&type=style&index=0&id=049f0b2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049f0b2e",
  null
  
)

export default component.exports